import { router } from '@inertiajs/react'
import { useEffect, useRef, useState } from 'react'

type Props = {
  name: string
  email: string
  role: string
  initials: string | null
  photoUrl: string | null
}

export default function ProfileMenu({ name, email, role, initials, photoUrl }: Props) {
  const [open, setOpen] = useState(false)
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!open) return
    const onClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false)
    }
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false)
    }
    document.addEventListener('mousedown', onClick)
    document.addEventListener('keydown', onKey)
    return () => {
      document.removeEventListener('mousedown', onClick)
      document.removeEventListener('keydown', onKey)
    }
  }, [open])

  return (
    <div ref={ref} className="relative">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="flex h-9 w-9 items-center justify-center overflow-hidden rounded-full border border-white/20 bg-white/10 font-display text-sm font-medium text-white transition hover:bg-white/20"
        aria-label="Open profile menu"
      >
        {photoUrl ? (
          <img src={photoUrl} alt="" className="h-full w-full object-cover" />
        ) : (
          <span>{initials || '?'}</span>
        )}
      </button>

      {open && (
        <div className="absolute right-0 top-full z-20 mt-2 w-60 rounded-lg border border-gray-200 bg-white py-2 shadow-lg">
          <div className="border-b border-gray-100 px-4 py-3">
            <p className="font-display text-sm font-medium text-midnight-green">{name}</p>
            <p className="truncate text-xs text-gray-500">{email}</p>
            <p className="mt-1 text-xs font-medium uppercase tracking-wider text-gray-400">
              {role}
            </p>
          </div>
          <button
            type="button"
            onClick={() => router.delete('/logout')}
            className="block w-full px-4 py-2 text-left font-display text-sm font-medium text-gray-700 transition hover:bg-gray-50"
          >
            Log out
          </button>
        </div>
      )}
    </div>
  )
}
